import { render, staticRenderFns } from "./RowBlockBuyingInsurance.vue?vue&type=template&id=e166a37c&"
import script from "./RowBlockBuyingInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports